import { createSlice } from "@reduxjs/toolkit";

/**
 * Player Redux Slice
 *
 * Manages player-related global UI state:
 * - Menu locking during playback (prevents nav interference)
 * - Active player source tracking
 * - Fullscreen state
 *
 * Ported from App-WebTV/src/redux/Slices/player.slice.js
 * Adapted: uses Redux Toolkit createSlice instead of manual action types.
 */

const initialState = {
    locked_menu: false,
    activeSource: null,
    isFullscreen: false,
    currentContentKey: null,
    currentEpisode: null,
    currentSeason: null,
};

const playerSlice = createSlice({
    name: "player",
    initialState,
    reducers: {
        lockMenu: (state) => {
            state.locked_menu = true;
        },
        unlockMenu: (state) => {
            return { ...initialState };
        },
        setActiveSource: (state, action) => {
            state.activeSource = action.payload;
        },
        setFullscreen: (state, action) => {
            state.isFullscreen = action.payload;
        },
        setCurrentContent: (state, action) => {
            state.currentContentKey = action.payload.contentKey;
            state.currentEpisode = action.payload.episode ?? null;
            state.currentSeason = action.payload.season ?? null;
        },
        clearCurrentContent: (state) => {
            state.currentContentKey = null;
            state.currentEpisode = null;
            state.currentSeason = null;
        },
    },
});

export const {
    lockMenu,
    unlockMenu,
    setActiveSource,
    setFullscreen,
    setCurrentContent,
    clearCurrentContent,
} = playerSlice.actions;

export default playerSlice.reducer;
